import { Header } from "components/Header"
import { EmployeeForm } from "components/employee-form"
import { ActivityIndicator } from "react-native"
import { trpc } from "utils/trpc"
import { useLocalSearchParams } from "expo-router"
import { ar } from "i18n/ar"

export default function EditEmployee() {
  const { id } = useLocalSearchParams<{ id: string }>()
  const employeeId = Number.parseInt(id, 10)
  const employee = trpc.employees.get.useQuery({ id: employeeId })

  if (employee.isLoading) {
    return (
      <>
        <Header title={ar.editEmployee} />
        <ActivityIndicator className="mx-auto mt-8" />
      </>
    )
  }

  return (
    <>
      <Header title={ar.editEmployee} />
      <EmployeeForm id={employeeId} />
    </>
  )
}
